module.exports = __webpack_public_path__ + "img/Albinit.b7aa3111.png";